<template>
  <div class="home_container" :class="[isNewSkin ? 'home_container_bg_new' : 'home_container_bg']">
    <div class="header_container">
      <div class="logo">
        <img src="../assets/image/logo.png" alt />
      </div>
      <div class="centerBtn">
        <div class="RuleBtn" @click="activityRule()">
          <!-- 旧按钮路径 -->
          <img v-if="!isNewSkin" src="../assets/image/button/activityRule.png" alt />
          <!-- 新按钮路径 -->
          <img v-else src="../assets/image/gameImages/button/activityRule.png" alt />
        </div>
      </div>
      <div class="rightBtn">
        <div class="myGiftBtn" @click="myGiftBtn()">
          <!-- 旧按钮路径 -->
          <img v-if="!isNewSkin" src="../assets/image/button/myGift.png" alt />
          <!-- 新按钮路径 -->
          <img v-else src="../assets/image/gameImages/button/myGift.png" alt />
        </div>
      </div>
      <div class="rightIcon"></div>
    </div>
    <div class="content_container">
      <div class="content_box" :class="[isNewSkin ? 'content_box_bg_new' : 'content_box_bg']">
        <div class="text_Box">
          {{ textTips }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textTips: '感谢您的参与，奖品可在【我的奖品】列表中查看。奖品将在活动结束的两周内快递送达~',
      isNewSkin: false, // 是否新皮肤
    };
  },
  mounted() {
    this.getTips();
    this.isNewSkin = sessionStorage.getItem('isNewSkin') ? true : false;
  },
  methods: {
    activityRule() {
      this.$router.push({ name: "activityRule" });
    },
    myGiftBtn() {
      this.$router.push({ name: "myGiftAll" });
    },
    async getTips() {
      let { data: result } = await this.$get(`/consumer/mkt-activity/getRealGiftMessage`);
      if (result.code !== 200) {
        return Toast(result.errMsg);
      }

      this.textTips = result.data.value || this.textTips;
    },
  },
  beforeCreate() {
    document.title = "抽奖";
  }
};
</script>

<style lang="scss" scoped>
/deep/.van-cell {
  width: 100%;
  height: 100%;
  background-color: #dcf6ff;
  line-height: 35px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.home_container {
  width: 100%;
  height: 100%;
  padding-top: 20px;
  // background-image: url("../assets/image/bgc01.png");
  background-size: 100% 100%;
  .header_container {
    width: 100%;
    height: 60px;
    display: flex;
    .logo {
      flex: 3;
      padding-left: 15px;
      img {
        width: 100%;
      }
    }
    .centerBtn {
      flex: 2;
      padding-left: 20px;
      .RuleBtn {
        width: 90%;
        height: 100%;
        img {
          width: 100%;
        }
      }
    }
    .rightBtn {
      flex: 2;
      padding-left: 10px;
      .myGiftBtn {
        width: 90%;
        height: 100%;
        img {
          width: 100%;
        }
      }
    }
    .rightIcon {
      width: 20px;
      padding-left: 10px;
      padding-top: 5px;
      img {
        width: 50%;
      }
    }
  }
  .content_container {
    margin-top: 30px;
    width: 100%;
    height: 500px;
    .content_box {
      width: 370px;
      height: 100%;
      margin: 0 auto;
      // background-image: url(../assets/image/redBgc04.png);
      background-size: cover;
      padding-top: 150px;
      .text_Box {
        width: 55%;
        min-height: 100px;
        margin: 0 auto;
        font-size: 23px;
        color: white;
        text-align: center;
      }
    }
    .content_box_bg {
      // 旧背景路径
      background-image: url('../assets/image/redBgc04.png');
    }
    .content_box_bg_new {
      // 新背景路径
      background-image: url('../assets/image/gameImages/redBgc04.png');  
    }
  }
}
.home_container_bg {
  // 旧背景路径
	background-image: url('../assets/image/bgc01.png');
}
.home_container_bg_new {
  // 新背景路径
  background-image: url('../assets/image/gameImages/bgc01.png');
}
</style>
